import React, { RefObject, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";

import { DropdownOption, IDSSDropdownProps, ISearchObject } from "../../../building-blocks/DSSFramework";
import './index.scss';
import DropDownOptions from "./DropDown";
import classNames from "classnames";
import SearchInputDropDown from "../search-input";
import { all } from "axios";

const Select = (props: IDSSDropdownProps): JSX.Element => {
    const [showOption, setShowOption] = useState(false);
    const [currentSelected, setCurrentSelected] = useState<string>("");
    const [visibleCount, setVisibleCount] = useState(100);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [dynamicOptions, setDynamicOptions] = useState<DropdownOption[]>([]);
    const dropdownRef = useRef<HTMLUListElement>(null);
    const dropdownRefxyz = useRef<HTMLDivElement>(null);
    const currentdivref = useRef<HTMLDivElement>(null);
    const [selfElement, setSelfElement] = useState<HTMLDivElement | null>(null);
    const [top, setTop] = useState<number>(0);
    const [left, setLeft] = useState<number>(0);

    const optionRefs = useRef<(HTMLDivElement | null)[]>([]);

    const [selectedIndex, setSelectedIndex] = useState(0);


    const getAllOptions = () => {
        if (props.options && props.options.length > 0) {
            return props.options;
        }
        return dynamicOptions;
    };

    useEffect(() => {
        setVisibleCount(100); // Reset visible count on search
    }, [searchTerm]);

    useEffect(() => {
        setCurrentSelected((props.value ?? "").toString());
    }, [props.value]);





    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        if (currentdivref?.current) {
            const element: HTMLDivElement = currentdivref.current;
            setSelfElement(element);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    useLayoutEffect(() => {
        if (selfElement) {
            const { top, left } = currentdivref.current?.getBoundingClientRect() ?? { top: 0, left: 0 };


            setTop(top);
            setLeft(left);
        }
    }, [selfElement, showOption]);

    const [selectedLabels, setSelectedLabels] = useState<string>('');

    // Whenever dynamicOptions or currentSelected changes, update the selected labels
    useEffect(() => {
        const selectedValues = props.isMultiple
            ? currentSelected.split(',')
            : [currentSelected];
        const labels = selectedValues.map(val => {
            const opt = getAllOptions().find(opt => opt.value?.toString() === val.toString());
            return opt?.label ?? '';
        }).filter(label => label !== '');
        setSelectedIndex(0);
        setSelectedLabels(labels.join(', '));

    }, [dynamicOptions, props.options, currentSelected]);

    useEffect(() => {
        if (props.value !== undefined && props.value !== null && props.value !== '' && dynamicOptions.length === 0) {
            getDynamicOptionsForEdit(props.value);
        }
    }, [
        props.value
    ])


    useEffect(() => {
        const currentOption = optionRefs.current[selectedIndex];
        if (currentOption) {
            currentOption.scrollIntoView({ block: 'nearest' });
        }
    }, [selectedIndex]);

    const updateDropdownPosition = () => {
        if (dropdownRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            const layouttop = rect.top
            const height = window.innerHeight;
            const availableheight = height - layouttop - 10; // 10px for margin
            const maxHeight = Math.min(availableheight, window.innerHeight * 0.2);
            dropdownRef.current.style.maxHeight = `${maxHeight}px`; // Set a max height for the dropdown
        }
    }
    useLayoutEffect(() => {
        if (showOption) {
            updateDropdownPosition();
            window.addEventListener('load', updateDropdownPosition);
            window.addEventListener('resize', updateDropdownPosition);
        }
        return () => {

            window.removeEventListener('load', updateDropdownPosition);
            window.removeEventListener('resize', updateDropdownPosition);
        };
    }, [showOption]);
    const getDynamicOptionsForEdit = useCallback(async (values: string) => {
        if (props.onSearch) {
            const options: any = await props.onSearch(values, true)
            setDynamicOptions(options);

        }
    }, [props.value])




    const debounce = (fn: Function, delay: number) => {
        let timer: any;
        return (...args: any) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    };



    const handleOnChangeSearch = useCallback(debounce(async (val: string) => {
        setSearchTerm(val);

        if (props.options && props.options.length > 0) {
            // Static options already provided, so search locally
            return;
        }

        if (props.onSearch && val.length > 2) {
            const remoteOptions: any = await props.onSearch(val);
            const selectedValues = currentSelected.split(',');

            // Fetch selected options from current props.options or from previous dynamicOptions
            const selectedOptions: DropdownOption[] = [];

            // Find selected options in dynamicOptions
            selectedValues.forEach((selectedValue) => {
                let found = dynamicOptions.find(opt => opt.value.toString() === selectedValue.toString());
                if (!found) {
                    // If not found in dynamicOptions, fallback to remote options
                    found = remoteOptions.find((opt: any) => opt.value?.toString() === selectedValue.toString());
                }
                if (found) {
                    selectedOptions.push(found);
                }
            });

            // Merge selectedOptions with newly fetched remote options (excluding duplicates)
            const mergedOptions: any = [
                ...selectedOptions,
                ...remoteOptions.filter((opt: any) => !selectedValues.includes(opt.value.toString()))
            ];

            setDynamicOptions(mergedOptions);
        }
    }, 300), [props.onSearch, currentSelected, dynamicOptions]);

    const handleClickOutside = (event: MouseEvent) => {
        const targetNode = event.target as Node;

        const clickedInsideDropdown = !!dropdownRefxyz.current?.contains(targetNode);
        const clickedInsideTrigger = !!currentdivref.current?.contains(targetNode);

        if (!clickedInsideDropdown && !clickedInsideTrigger) {
            setShowOption(false);

        }
    };

    const handleListClick = (option: DropdownOption, i: number) => {

        setSelectedIndex(i);
        if (!props.isMultiple && getSelected(option)) {
            setShowOption(false);
            return
        }
        let finalval = currentSelected ? currentSelected.split(',') : [];
        if (props.isMultiple) {
            if (finalval.includes(option.value.toString())) {
                finalval = finalval.filter(id => id !== option.value.toString());
            }
            else {
                finalval = [option.value.toString(), ...finalval];
            }
        }


        else {
            finalval = [option.value.toString()];
            setShowOption(false);

        }
        const finalLabel = finalval.map(m => getAllOptions().find(f => f.value.toString() === m.toString())?.label ?? '');
        const finalIdentifier = finalval.map(m => getAllOptions().find(f => f.value.toString() === m.toString())?.identifier ?? null).filter(f => f !== null);
        props.onChange && props.onChange(finalval.join(','), finalLabel.join(','), finalIdentifier);
        setCurrentSelected(finalval.join(','));

    };

    // Select All logic
    const isSelectAllChecked = useMemo(() => {
        if (!props.isMultiple || !props.enableMarkBox) return false;
        const options = getAllOptions().filter(opt => !!String(opt.label).trim());
        if (options.length === 0) return false;
        const selectedValues = currentSelected.split(',');
        return options.every(opt => selectedValues.includes(opt.value.toString()));
    }, [props.isMultiple, props.enableMarkBox, currentSelected, dynamicOptions, props.options]);

    const handleSelectAll = () => {
        const options = getAllOptions().filter(opt => !!String(opt.label).trim());
        if (isSelectAllChecked) {
            // Deselect all
            props.onChange && props.onChange('', '');
            setCurrentSelected('');
        } else {
            // Select all
            const allValues = options.map(opt => opt.value.toString());
            const allLabels = options.map(opt => opt.label ?? '').join(', ');
            props.onChange && props.onChange(allValues.join(','), allLabels);
            setCurrentSelected(allValues.join(','));
        }
    };




    const allOptions = useMemo(() => {
        let options = getAllOptions();
        if (searchTerm.trim() !== "") {
            options = options.filter((o: DropdownOption) =>
                String(o.label).toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        if (props.sort === 'NA') {
            return options.filter(f => !!String(f.label).trim()) ?? [];
        }

        const selectedSet = new Set(currentSelected.split(','));
        const selected = options?.filter((o) => selectedSet.has(o?.value?.toString()));
        const unselected = options?.filter((o) => !selectedSet.has(o?.value?.toString()));

        //Sorting Label Wise
        let finalListWithEmptyValue: DropdownOption[];
        if (props.sort === undefined) {
            finalListWithEmptyValue = [...unselected].slice(0, visibleCount)
                .sort((a: DropdownOption, b: DropdownOption) => String(a.label ?? "").localeCompare(String(b.label ?? ""), undefined, { sensitivity: 'base' }));
        } else if (props.sort !== 'DSC') {
            finalListWithEmptyValue = [...unselected].slice(0, visibleCount)
                .sort((a: DropdownOption, b: DropdownOption) => String(a.label ?? "").localeCompare(String(b.label ?? ""), undefined, { sensitivity: 'base' }));
        } else {
            finalListWithEmptyValue = [...unselected].slice(0, visibleCount)
                .sort((a: DropdownOption, b: DropdownOption) => String(b.label ?? "").localeCompare(String(a.label ?? ""), undefined, { sensitivity: 'base' }));
        }

        //Removing Empty label if any
        return ([...selected, ...(finalListWithEmptyValue ?? [])]).filter(f => !!String(f.label).trim()) ?? []
    }, [props.options, dynamicOptions, searchTerm, currentSelected, visibleCount]);

    const getSelected = (opt: DropdownOption): boolean => {
        const isSelected = currentSelected.split(',').includes(opt.value.toString()) ?? false;

        return isSelected;
    }

    const setIfSelected = (opt: DropdownOption) => {
        if (getSelected(opt)) {
            if (props.enableMarkBox) { return 'selected blue'; }
            return 'selected';
        }
        return '';
    }


    const searchInput = useRef<{ focus: () => void }>(null);

    const handleScroll = useCallback((e: React.UIEvent<HTMLUListElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (scrollHeight - scrollTop - clientHeight < 50) {
            // near bottom
            setVisibleCount((prev) => prev + 100); // load more
        }
    }, []);

    const handeleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (props.disabled) {
            return;
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (showOption === true)
                setSelectedIndex((prev) => (prev + 1) % allOptions.length);
            else {
                setShowOption(true);
            }

        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setSelectedIndex((prev) => (prev - 1 + allOptions.length) % allOptions.length);
        } else if (e.key === ' ') {
            e.preventDefault();
            setShowOption(true);
        }
        else if (e.key === 'Enter') {
            e.preventDefault();
            const selectedOption = allOptions[selectedIndex];
            if (selectedOption) {
                handleListClick(selectedOption, selectedIndex);
            }
        }
        else if (e.key === 'Escape') {
            e.preventDefault()
            setShowOption(false);
        }

        else if (e.key === 'Tab') {

            setShowOption(false)
        }
        else if (/^[a-zA-Z]$/.test(e.key)) {
            const key = e.key.toLowerCase();
            const idx = allOptions.findIndex(opt =>
                typeof opt.label === 'string' && opt.label.trim().toLowerCase().startsWith(key)
            );
            if (idx !== -1) {
                setSelectedIndex(idx);
                const currentOption = optionRefs.current[idx];
                if (currentOption) {
                    currentOption.scrollIntoView({ block: 'nearest' });
                }
            }
        }
    }

    return (
        <>
            <div
                data-testid={props.dataTestId ?? props.id}
                ref={currentdivref}
                tabIndex={0}
                role="<li>"
                className={classNames("dssselect", props.className, (props.disabled ? 'disabled' : ''))}
                onClick={() => {

                    if (props.disabled) {
                        setShowOption(false);
                    } else {
                        setShowOption(prev => !prev);
                    }
                }}

                onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                    handeleKeyDown(event);
                }}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
            >

                <span className="value">
                    {selectedLabels || <span className="ddplaceholder">{props.placeholder || 'Select'}</span>}
                </span>
                <div className="divider"></div>
                {!props.disabled && <div className="caret"></div>}

            </div>

            {showOption && (
                <div className="dropdown-scroll-container" >
                    <DropDownOptions width={+(selfElement?.offsetWidth.toString() || '0')}
                        height={+(selfElement?.offsetHeight.toString() || '0')}
                        targetRef={currentdivref}
                        top={top} left={left}>
                        <div ref={dropdownRefxyz} style={{ width: "100%" }}>
                            {props.isSearchEnable && (
                                <SearchInputDropDown
                                    ref={searchInput}
                                    placeholder={props.placeholder ?? 'Search'}
                                    style={{ width: "100%" }}
                                    value={searchTerm}
                                    onChange={handleOnChangeSearch}
                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {

                                        handeleKeyDown(e as any as React.KeyboardEvent<HTMLDivElement>);
                                    }}
                                />
                            )}
                            <ul className="ul options show"
                                ref={dropdownRef}
                                onScroll={handleScroll}>

                                {props.isMultiple && props.enableMarkBox && allOptions && allOptions.length > 0 && (
                                    <div style={{ padding: "0.51rem", borderBottom: "1px solid #eee" }}>
                                        <label className="lablemark">
                                            <input
                                                type="checkbox"
                                                id="checkbox-select-all"
                                                data-testid="checkbox-select-all"
                                                checked={isSelectAllChecked}
                                                onChange={handleSelectAll}
                                                className="option select-all-checkbox"
                                            />
                                            Select All
                                        </label>
                                    </div>
                                )}
                                {allOptions && allOptions.length > 0 ?
                                    allOptions.map((opt: DropdownOption, i: number) => (
                                        <div key={opt.value.toString() + '_' + i}
                                            className={`${i === selectedIndex ? 'arrowhighlighted' : ''}`}
                                            tabIndex={i}
                                            role="<option>"
                                            aria-selected={i === selectedIndex}
                                            ref={(el) => { optionRefs.current[i] = el; }}

                                        >
                                            {
                                                props.enableMarkBox ? (
                                                    <div style={{ padding: "0.51rem" }}
                                                    >
                                                        <label className="lablemark">
                                                            <input
                                                                {...props}
                                                                id={`checkbox-${opt.value}-${i}`}
                                                                data-testid={`checkbox-${opt.value}-${i}`}
                                                                type="checkbox"
                                                                name={opt.value}
                                                                value={opt.value}
                                                                checked={getSelected(opt)}
                                                                className={`option ${setIfSelected(opt)}`}
                                                                onChange={() => handleListClick(opt, i)}
                                                            />
                                                            {opt.label}
                                                        </label>
                                                    </div>
                                                ) : (
                                                    <div
                                                        data-testid={opt.value.toString()}
                                                        className={`option ${setIfSelected(opt)}`}
                                                        onClick={() => handleListClick(opt, i)}
                                                        role="<li>"
                                                    >
                                                        {opt.useCustomRenderer ? opt.customRenderer : opt.label}

                                                    </div>
                                                )
                                            }
                                        </div>
                                    )) : (
                                        <li className="li option disabled">No options available</li>
                                    )}
                            </ul>
                        </div>
                    </DropDownOptions>
                </div>
            )}
        </>
    );

};




export default React.memo(Select);